<template>
  <div style="width: 100%;position: relative">
    <div
      class="k-multiple-input-tag"
      :class="{
      'on-focus': focusStatus,
      'has-item': inputItem.length > 0,
      'has-error': hasError || inputError,
      'disabled': isDisabled
    }">
      <!-- 数据区域 -->
      <div class="items-input">
        <!-- 已输入项 -->
        <div
          class="item k-body-md"
          :class="{'no-delete': isDisabled, 'item-disabled': isDisabled}"
          v-for="(item, index) in inputItem" :key="index"
        >
          <span class="text">{{ item }}</span>
          <span
            v-if="!isDisabled"
            @click="doDeleteItem(item)"
          >
          <KkIcon name="ic_cross_line" size="xs" class="kk-u-text-primary-medium k-icon-cursor" />
        </span>
        </div>
        <!-- 实时录入 -->
        <input
          type="text"
          class="multiple-input"
          :disabled="isDisabled"
          :class="{'input-error': inputError, 'input-disabled': isDisabled}"
          v-model="input"
          :placeholder="placeholder"
          @keyup.enter="onAddSubmit"
          @keyup.space="onAddSubmit"
          @keyup.188="onAddSubmit"
          @keydown.delete="onDeleteKeyUp"
          @focus="onFocus"
          @blur="onBlur"
        >
      </div>
      <!-- add 按钮区域 -->
      <div class="manual-add">
        <div class="add-btn" v-show="input" @click="onAddSubmit">ADD</div>
      </div>
    </div>
    <template v-if="inputError && !hasError">
      <KkMessage :message="`Duplicate tag(s):${input}`" />
    </template>
  </div>
</template>

<script>
import _ from 'lodash'
import { KkIcon, KkMessage } from '@kkday/web-design-system'

export default {
  components: {
    KkIcon,
    KkMessage
  },
  data() {
    return {
      focusStatus: false,
      input: '',
      inputItem: this.value || [],
      inputError: false
    }
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    isNumber: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    },
    max: {
      type: Number,
      default: 0
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    hasError: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    input: {
      handler(val) {
        if (this.inputItem?.includes(val)) {
          this.inputError = true
          return
        }
        this.inputError = false
      }
    },
    value: {
      handler(val) {
        this.inputItem = _.cloneDeep(val)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 添加功能：回车新增、逗号新增、空格新增、点击add新增、复制&粘贴后手动触发
    // 移除功能：键盘删除、点击删除
    // 回调：删除完成回调、新增完成回调、重复添加提示回调
    onFocus() {
      this.focusStatus = true
    },
    onBlur() {
      this.focusStatus = false
    },
    onAddSubmit() {
      // 支持复制粘贴来的 123,12315，9876 923,876,，76523
      // 如果有包含「逗号、空格」，则按「逗号、空格」截断整体字符串，并按序批次加入
      const inputArr = this.getInputSplit(this.input)
      if (_.isEmpty(inputArr) || inputArr == undefined) {
        return false
      }
      // 数量是否超限
      if (this.max > 0 && this.inputItem.length + inputArr.length >= this.max) {
        this.inputError = true
        this.onErrorCallback({'max': this.inputItem.length})
        return
      }
      for (let i = 0; i <= inputArr.length; i++) {
        if (!_.isEmpty(inputArr[i])) {
          // 非纯数字检测
          if (this.isNumber && !/^\d+$/.test(inputArr[i])) {
            this.inputError = true
            this.onErrorCallback({'number': inputArr[i]})
            return
          }
          // 这样防止数据中有数字，将所有元素转字符串后再比对
          if (_.findIndex(this.inputItem, function(item) {
            return item.toString() == inputArr[i]
          }) > -1) {
            this.inputError = true
            this.onErrorCallback({'repeat': inputArr[i]})
            return
          }
          this.inputItem.push(inputArr[i])
        }
        this.input = ''
      }
      this.onChangeCallback()
    },
    getInputSplit(input) {
      if (_.isEmpty(input) || input == undefined) {
        return []
      }

      // 先将中文逗号 & 空格统一转成英文逗号
      let inputStr = input

      inputStr = _.replace(inputStr, new RegExp("，", "g"), ',')
      inputStr = _.replace(inputStr, new RegExp(" ", "g"), ',')

      let inputArr = []
      const split = _.split(inputStr, ',')
      _.map(split, function(item) {
        if (!_.isEmpty(item) && item !=undefined) {
          inputArr.push(item)
        }
      })

      return _.uniq(inputArr)
    },
    doDeleteItem(v) {
      this.inputItem = this.inputItem.filter(item => item != v)
      this.onChangeCallback()
    },
    onDeleteKeyUp() {
      // 键盘删除，按顺序删除
      if (this.inputItem.length > 0 && _.isEmpty(this.input)) {
        this.inputItem = _.dropRight(this.inputItem)
        this.onChangeCallback()
      }
    },
    onChangeCallback() {
      this.$emit('input', this.inputItem)
      this.$emit('change', this.inputItem)
    },
    onErrorCallback(error) {
      this.$emit('error', error)
    }
  }
}
</script>

<style lang="less" scoped>
// 边框状态：正常状态、焦点状态、鼠标悬停
.k-multiple-input-tag:hover {
  border: 1px solid #212121;
}
.on-focus {
  border: 1px solid #212121 !important;
}
.has-item {
  padding: 2px 12px !important;
}
.input-error {
  color: #E65F50;
}
.disabled {
  border: 1px solid #E6E9ED !important;
  color: #BABBBE !important;
  background-color: #F1F4F8 !important;
  cursor: no-drop;
  cursor: not-allowed;
}
.input-disabled {
  border: 1px solid #F1F4F8 !important;
  color: #BABBBE !important;
  background-color: #F1F4F8 !important;
  cursor: no-drop;
  cursor: not-allowed;
}
.k-multiple-input-tag {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  box-sizing: border-box;
  padding: 7px 12px;
  border: 1px solid #D5D6DB;
  border-radius: 8px;
  background-color: #FFF;
  .items-input {
    width: 100%;
    display: flex;
    flex-flow: wrap;
    align-items: center;
    .item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      padding: 6px 10px 6px 14px;
      margin: 4px 8px 4px 0px;
      border-radius: 20px;
      color: #26BEC9;
      border: 1px solid #26BEC9;
      background-color: #F0FAFB;
      .text {
        overflow: hidden;
        text-overflow: ellipsis;
        word-wrap: break-word;
        word-break: break-all;
        text-align: left;
      }
    }
    .item-disabled {
      color: #ADE6EB !important;
      border: 1px solid #ADE6EB !important;
    }
    .no-delete {
      padding: 6px 14px !important;
    }
    .multiple-input {
      width: 50%;
      min-width: 180px;
      padding: 6px 0px;
      flex: 1;
      height: 20px;
      border: none;
      outline: none;
    }
    .multiple-input:focus {
      border: none;
      outline: none;
    }
    .multiple-input::placeholder {
      color: #BABBBE;
    }
    .multiple-input::-ms-input-placeholder {
      color: #BABBBE;
    }
  }
  .manual-add {
    width: 80px;
    height: 32px;
    line-height: 32px;
    .add-btn {
      box-sizing: border-box;
      padding: 0px 24px;
      color: #26BEC9;
      cursor: pointer;
    }
  }
}
.has-error {
  border: 1px solid #E65F50 !important;
}
</style>
